export { ExpenseTable, type ExpenseTableProps, type StringIdentifiable } from './ExpenseTable';
export { FooterCellStyled as FooterCell, TypographyFullWidth } from './expense-table.styled';
export { type CreateColumns } from './hooks/useExpenseTableColumns';
